module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('p', {
    staticClass: "NADL-1"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("November 6, 1937")])]), _vm._v(" "), _c('p', {
    staticClass: "NADL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Los Angeles Register")])]), _vm._v(" "), _c('p', {
    staticClass: "NAH-1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("‘ALLEY ANGEL’ SLAIN IN HOLLYWOOD")])]), _vm._v(" "), _c('p', {
    staticClass: "NASH"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Mystery Woman in Fashion Finery")])]), _vm._v(" "), _c('p', {
    staticClass: "NAT"
  }, [_c('span', {
    staticClass: "nat"
  }, [_vm._v("LOS ANGELES, NOV. 5 (AP)")]), _vm._v(" - The body of an unidentified woman was found in an alley behind a butcher shop in Hollywood today. The woman had been shot several times, according to police sources. More baffling to authorities, the woman was dressed in attire more suited to a movie colony premiere than the humble environs where she was discovered.")]), _vm._v(" "), _c('p', {
    staticClass: "NATI"
  }, [_vm._v("The body, draped in a silk gown and numerous shimmering stones, was found in the early hours of November 5 by an employee of the shop. “She looked like an angel,” said Spyros Makadoulis, age 41. “Like she’d fallen from heaven itself.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d01bd39","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 75
// module chunks = 0